var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{style:({ borderTop: _vm.color ? `7px solid ${_vm.color}` : '' })},[_c('p',{staticClass:"mb-1"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('h1',{staticClass:"text-truncate text-h6 font-weight-bold"},[_vm._v("\n      "+_vm._s(_vm.content || '-')+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }